import styled from 'styled-components';
import Markdown from 'react-markdown';

import { media } from '../../utils/media';
import { ContentContainer } from '../layout/layout.styles';

export const TitleWrapper = styled(ContentContainer)`
  padding: 15px 0 21px 0;
  margin: 0 40px 0 50px;

  ${media.tablet`
    margin: 0 30px;
  `}
`;

export const Title = styled(Markdown)`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5em;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.color};

  p {
    margin-bottom: 0;
  }
`;

export const VideoComponent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: calc(45vw - 20px);

  ${media.tablet`
    width: 100%;
    height: 450px;
  `}

  .embed_video {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
  }

  iframe {
    border: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin-bottom: 0;

    ${media.desktop`
      margin-bottom: unset;
    `}
  }
`;

export const Container = styled.div``;

export const CoverWrapper = styled.div`
  overflow: hidden;
  margin-bottom: -56.25%;
  cursor: pointer;
`;

export const ClickCover = styled.img`
  width: 100%;
  padding-bottom: 56.25%;
  margin-bottom: 20px;
`;
